import React from 'react'
import styled from 'styled-components'
import { SMALL_DEVICE } from '@constants/breakpoints'

const USERNAME = 's0_r4nd0m_sc4rrl37_x3'
const FRIEND_COUNT = 69
const GAP = 8

const Container = styled.div`
  border: 1px solid black;
`

const CardContainer = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  gap: ${GAP}px;
`

const Avatar = styled.div<{ $url: string }>`
  content: url("${props => props.$url}");
  border: 1px solid #ace;
  height: auto;
  width: 100%;
`

interface Friend {
  username: string
  avatarUrl: string
}

// TODO: pull from a "full" friend list and just take the top eight
const friends: Friend[] = [
  { username: 'coolfriend', avatarUrl: 'https://picsum.photos/200'},
  { username: 'coolfriend', avatarUrl: 'https://picsum.photos/200'},
  { username: 'coolfriend', avatarUrl: 'https://picsum.photos/200'},
  { username: 'coolfriend', avatarUrl: 'https://picsum.photos/200'},
  { username: 'coolfriend', avatarUrl: 'https://picsum.photos/200'},
  { username: 'coolfriend', avatarUrl: 'https://picsum.photos/200'},
  { username: 'coolfriend', avatarUrl: 'https://picsum.photos/200'},
  { username: 'coolfriend', avatarUrl: 'https://picsum.photos/200'},
]

const FriendCardContainer = styled.div`
  text-align: center;
  flex: 1 1 calc(25% - ${GAP}px);

  @media (width < ${SMALL_DEVICE.width}) {
    flex: 1 1 calc(50% - ${GAP}px);
  }
`

function FriendCard (friend: Friend) {
  return (
    <FriendCardContainer>
      <div>{ friend.username }</div>
      <Avatar $url={ friend.avatarUrl }></Avatar>
    </FriendCardContainer>
  )
}

const TitleCard = styled.div`
  margin-bottom: 8px;

  & > div {
    padding: 2px 4px;
  }
`

const Title = styled.div`
  color: pink;
  background: #ace;
  text-shadow: 1px 1px 2px black;
`

const Subtitle = styled.div`
  text-shadow: 1px 1px 2px pink;
`

const FriendCount = styled.span`
  display: inline-block;

  @keyframes pulsing-text {
    0%   {
      transform: scale(1);
    }
    25%   {
      transform: scale(1.1);
    }
    75%   {
      transform: scale(0.9);
    }
    100% {
      transform: scale(1);
    }
  }

  animation: pulsing-text 2s infinite linear;
`

export default function TopEight () {
  return (
    <Container>
      <TitleCard>
        <Title>{ USERNAME }'s Friend Space</Title>
        <Subtitle>{ USERNAME } has <FriendCount>{ FRIEND_COUNT }</FriendCount> friends.</Subtitle>
      </TitleCard>
      <CardContainer>
        { friends.map((friend, index) => <FriendCard key={ index } username={ friend.username } avatarUrl={ friend.avatarUrl }/> )}
      </CardContainer>
    </Container>
  )
}
